module.exports = __webpack_public_path__ + "catalog/items/firesafety/direction-diagonal-top-right/direction-diagonal-top-right.svg";